import { useMutation } from 'react-query'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useCache from '../../../hooks/use-cache'
import useApi from '../../../hooks/use-api'
import { get } from 'lodash'
import useToasts from '../../../hooks/use-toasts'

const useCourseDrop = ({
    courseId,
    onSuccess = () => {},
    onError = () => {}
}) => {
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: [cacheKeys.COURSES, courseId], onReload: onSuccess})
    const { api, url, endpoints } = useApi()
    const { toastSuccess } = useToasts({ successMessage: 'Student Removed!', onSuccess: clearCache })
    const { toastError } = useToasts()
    const [ drop, {isLoading} ] = useMutation(
        (userId ) => api.delete(url(endpoints.userCourseEnrollment, { userId, courseId })),
        {
            onSuccess: toastSuccess,
            onError: (response) => {
                switch (get(response, 'status')) {
                case 403:
                    toastError(get(response, 'data', 'UNKNOWN 403'))
                    onError()
                    break
                default:
                    toastError(`UNKNOWN ${get(response, 'status')}`)
                    onError()
                }
            }
        }
    )

    return {
        isLoading,
        drop
    }
}

export default useCourseDrop